export const store = {
	projects: [
		{
			id: 1,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-citibank.png'),
			imgalt: '시티은행 웹접근성 사업',
			prjtitle: '시티은행',
			prjname: '시티은행 웹접근성 사업',
			prjyear: '2012',
			pjdate: '10'
		},
		{
			id: 2,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdmobis.png'),
			imgalt: '현대모비스 액튠 마이크로사이트 구축',
			prjtitle: '현대모비스',
			prjname: '현대모비스 액튠 마이크로사이트 구축',
			prjyear: '2012',
			pjdate: '10'
		},
		{
			id: 3,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-innocean.png'),
			imgalt: '이노션 옥외매체 통합관리시스템 구축',
			prjtitle: '이노션',
			prjname: '이노션 옥외매체 통합관리시스템 구축',
			prjyear: '2012',
			pjdate: '11'
		},
		{
			id: 4,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo_hyundaishopping.png'),
			imgalt: '현대홈쇼핑 법인몰 구축',
			prjtitle: '현대홈쇼핑',
			prjname: '현대홈쇼핑 법인몰 구축',
			prjyear: '2012',
			pjdate: '11'
		},
		{
			id: 5,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-hdmotorgroup.png'),
			imgalt: '현대자동차그룹 글로벌 노무정보시스템 구축',
			prjtitle: '현대자동차',
			prjname: '현대자동차그룹 글로벌 노무정보시스템 구축',
			prjyear: '2012',
			pjdate: '12'
		},
		{
			id: 6,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-hdmotorgroup.png'),
			imgalt: '현대자동차그룹 사이트 개편',
			prjtitle: '현대자동차',
			prjname: '현대자동차그룹 사이트 개편',
			prjyear: '2012',
			pjdate: '12'
		},
		{
			id: 7,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-gsshop.png'),
			imgalt: 'GS SHOP',
			prjtitle: 'GS SHOP',
			prjname: 'GS SHOP 운영',
			prjyear: '2013',
			pjdate: '01'
		},
		{
			id: 8,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-eduwill.png'),
			imgalt: '에듀윌',
			prjtitle: '에듀윌',
			prjname: '에듀윌 평생교육원 학점은행제 사이트 구축',
			prjyear: '2013',
			pjdate: '01'
		},
		{
			id: 9,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-hdautoever.png'),
			imgalt: '현대오토에버',
			prjtitle: '현대오토에버',
			prjname: '현대오토에버 국/영문 개편',
			prjyear: '2013',
			pjdate: '02'
		},
		{
			id: 10,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-kiamotors.png'),
			imgalt: 'KT Global',
			prjtitle: 'KT Global',
			prjname: 'KT Global Domain Consolidation 도메인 통합',
			prjyear: '2013',
			pjdate: '04'
		},
		{
			id: 11,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-kiamotors.png'),
			imgalt: '기아자동차',
			prjtitle: '기아자동차',
			prjname: '기아자동차 국내판매홍보/용어사전 웹접근성 개선',
			prjyear: '2013',
			pjdate: '04'
		},
		{
			id: 12,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-ollehkt.png'),
			imgalt: 'KT 올레 SLP 구축',
			prjtitle: 'KT 올레',
			prjname: 'KT 올레 SLP 구축',
			prjyear: '2013',
			pjdate: '04'
		},
		{
			id: 13,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-lotteshopping.png'),
			imgalt: '롯데쇼핑 롭스 브랜스 사이트 구축',
			prjtitle: '롯데쇼핑',
			prjname: '롯데쇼핑 롭스 브랜스 사이트 구축',
			prjyear: '2013',
			pjdate: '05'
		},
		{
			id: 14,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-powertech.png'),
			imgalt: '현대파워텍 사이트 개편',
			prjtitle: '현대파워텍',
			prjname: '현대파워텍 사이트 개편',
			prjyear: '2013',
			pjdate: '07'
		},
		{
			id: 15,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-kiamotors.png'),
			imgalt: '기아자동차 펀키아 웹 접근성 개선',
			prjtitle: '기아자동차',
			prjname: '기아자동차 펀키아 웹 접근성 개선',
			prjyear: '2013',
			pjdate: '08'
		},
		{
			id: 16,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-keia.png'),
			imgalt: '한국원자력문화재단 가능성 게임 "에너지탐험대"제작',
			prjtitle: '한국원자력문화재단',
			prjname: '한국원자력문화재단 가능성 게임 "에너지탐험대"제작',
			prjyear: '2013',
			pjdate: '08'
		},
		{
			id: 17,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-thesaem.png'),
			imgalt: '더샘코스매틱 쇼핑몰 구축',
			prjtitle: '더샘코스메틱',
			prjname: '더샘코스매틱 쇼핑몰 구축',
			prjyear: '2013',
			pjdate: '08'
		},
		{
			id: 18,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-dymos.png'),
			imgalt: '현대다이모스 사이트 개편',
			prjtitle: '현대다이모스',
			prjname: '현대다이모스 사이트 개편',
			prjyear: '2013',
			pjdate: '11'
		},
		{
			id: 19,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdmotorgroup.png'),
			imgalt: '현대자동차 키즈현대 사이트 개편',
			prjtitle: '현대자동차',
			prjname: '현대자동차 키즈현대 사이트 개편',
			prjyear: '2013',
			pjdate: '12'
		},
		{
			id: 20,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdglovis.png'),
			imgalt: '현대글로비스 통합모니터링시스템 구축',
			prjtitle: '현대글로비스',
			prjname: '현대글로비스 통합모니터링시스템 구축',
			prjyear: '2013',
			pjdate: '12'
		},
		{
			id: 21,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-kiamotors.png'),
			imgalt: '기아자동차 Q멤버십 웹사이트 UI/UX개편',
			prjtitle: '기아자동차',
			prjname: '기아자동차 Q멤버십 웹사이트 UI/UX개편',
			prjyear: '2014',
			pjdate: '03'
		},
		{
			id: 22,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-hdglovis.png'),
			imgalt: '현대글로비스 통합모니터링 개선',
			prjtitle: '현대글로비스',
			prjname: '현대글로비스 통합모니터링 개선',
			prjyear: '2014',
			pjdate: '03'
		},
		{
			id: 23,
			category: 'travel',
			imgsrc: require('../../static/img/project/haevichi.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/haevichi-thumb.jpg'),
			imgalt: '해비치',
			imglayer: 'haevichi',
			prjUrl: 'haevichi',
			prjtitle: 'Haevichi Hotel & Resort',
			prjname: '해비치호텔 앤드 리조트 홈페이지 & 모바일 구축',
			prjyear: '2014',
			pjdate: '05'
		},
		{
			id: 24,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdglovis.png'),
			imgalt: '현대글로비스 모바일 오토옥션 개편',
			prjtitle: '현대글로비스',
			prjname: '현대글로비스 모바일 오토옥션 개편',
			prjyear: '2014',
			pjdate: '07'
		},
		{
			id: 25,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-meritzfire.png'),
			imgalt: '메리츠화재 TV-CF 온라인 프로모션',
			prjtitle: '메리츠화재',
			prjname: '메리츠화재 TV-CF 온라인 프로모션',
			prjyear: '2014',
			pjdate: '08'
		},
		{
			id: 26,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-innocean.png'),
			imgalt: '이노션 해외미디어 예산설정시스템 (INNO-SMART)구축',
			prjtitle: '이노션',
			prjname: '이노션 해외미디어 예산설정시스템 (INNO-SMART)구축',
			prjyear: '2014',
			pjdate: '09'
		},
		{
			id: 27,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdglovis.png'),
			imgalt: '현대글로비스 AIMS 지표항목 개발',
			prjtitle: '현대글로비스',
			prjname: '현대글로비스 AIMS 지표항목 개발',
			prjyear: '2014',
			pjdate: '10'
		},
		{
			id: 28,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-meritzfire.png'),
			imgalt: '메리츠화재 걱정인형 사이트 개편',
			prjtitle: '메르츠화재',
			prjname: '메리츠화재 걱정인형 사이트 개편',
			prjyear: '2014',
			pjdate: '12'
		},
		{
			id: 29,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-hdglovis.png'),
			imgalt: '현대글로비스 지원시스템 개선',
			prjtitle: '현대글로비스',
			prjname: '현대글로비스 지원시스템 개선',
			prjyear: '2014',
			pjdate: '12'
		},
		{
			id: 30,
			category: 'etc',
			imgsrc: require('../../static/img/project/design-samsung.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/design-samsung-thumb.jpg'),
			imgalt: '디자인 삼성',
			imglayer: 'design-samsung',
			prjUrl: 'design-samsung',
			prjtitle: 'DESIGN SAMSUNG',
			prjname: '디자인 삼성 컨텐츠 유지보수',
			prjyear: '2015',
			pjdate: '02'
		},
		{
			id: 31,
			category: 'corporation',
			imgsrc: require('../../static/img/project/hsteel.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/hsteel-thumb.jpg'),
			imgalt: '현대제철',
			imglayer: 'hsteel',
			prjUrl: 'hyundai-steel',
			prjtitle: 'HYUNDAI STEEL',
			prjname: '현대제철 홈페이지 & 모바일 구축',
			prjyear: '2015',
			pjdate: '02'
		},
		{
			id: 32,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-kgeu.png'),
			imgalt: '전국광역시 공무원 노동조합 복지몰 구축',
			prjtitle: '전국광역시 공무원 노동조합',
			prjname: '전국광역시 공무원 노동조합 복지몰 구축',
			prjyear: '2015',
			pjdate: '05'
		},
		{
			id: 33,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-archery.png'),
			imgalt: '대한양궁협회 홈페이지 개편',
			prjtitle: '대한양궁협회',
			prjname: '대한양궁협회 홈페이지 개편',
			prjyear: '2015',
			pjdate: '06'
		},
		{
			id: 34,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-lottefood.png'),
			imgalt: '롯데푸드 파스퇴르몰 모바일 웹/APP 구축',
			prjtitle: '롯데푸드',
			prjname: '롯데푸드 파스퇴르몰 모바일 웹/APP 구축',
			prjyear: '2015',
			pjdate: '07'
		},
		{
			id: 35,
			category: 'corporation',
			imgsrc: require('../../static/img/project/hyundai-partecs.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/hyundai-partecs-thumb.jpg'),
			imgalt: '현대파텍스',
			imglayer: 'partecs',
			prjUrl: 'partecs',
			prjtitle: 'HYUNDAI Partecs',
			prjname: '현대파텍스 홈페이지 구축',
			prjyear: '2015',
			pjdate: '12'
		},
		{
			id: 36,
			category: 'corporation',
			imgsrc: require('../../static/img/project/lotte.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lotte-thumb.jpg'),
			imgalt: '롯데그룹',
			imglayer: 'lotte-group',
			prjUrl: 'lotte-group',
			prjtitle: 'LOTTE Group',
			prjname: '롯데그룹 모바일 구축',
			prjyear: '2015',
			pjdate: '12'
		},
		{
			id: 37,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-lottehomeshopping.png'),
			imgalt: '롯데ONE TV 모바일 웹/APP 구축',
			prjtitle: '롯데ONE',
			prjname: '롯데ONE TV 모바일 웹/APP 구축',
			prjyear: '2016',
			pjdate: '04'
		},
		{
			id: 38,
			category: 'corporation',
			imgsrc: require('../../static/img/project/lgchem.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lgchem-thumb.jpg'),
			imgalt: 'LG화학',
			imglayer: 'lgchem',
			prjUrl: 'lgchem',
			prjtitle: 'LG Chem',
			prjname: 'LG화학 홈페이지 & 모바일 개편',
			prjyear: '2016',
			pjdate: '01'
		},
		{
			id: 39,
			category: 'corporation',
			imgsrc: require('../../static/img/project/shilla-ipark.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/shilla-ipark-thumb.jpg'),
			imgalt: '신라아이파크면세점',
			imglayer: 'shilla-ipark',
			prjUrl: 'ipark-duty-free',
			prjtitle: 'Shilla I’PARK Duty Free',
			prjname: '신라아이파크 면세점 홈페이지 & 모바일 구축',
			prjyear: '2016',
			pjdate: '01'
		},
		{
			id: 40,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-lottehomeshopping.png'),
			imgalt: '롯데아이몰 모바일 부분 개편',
			prjtitle: '롯데아이몰',
			prjname: '롯데아이몰 모바일 부분 개편',
			prjyear: '2016',
			pjdate: '04'
		},
		{
			id: 41,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-lottedotcom.png'),
			imgalt: '롯데 피트인 개편',
			prjtitle: '롯데',
			prjname: '롯데 피트인 개편',
			prjyear: '2016',
			pjdate: '04'
		},
		{
			id: 42,
			category: 'corporation',
			imgsrc: require('../../static/img/project/ket.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/ket-thumb.jpg'),
			imgalt: '한국단자',
			imglayer: 'ket',
			prjUrl: 'ket',
			prjtitle: 'KET',
			prjname: '한국단자 홈페이지 구축',
			prjyear: '2016',
			pjdate: '05'
		},
		{
			id: 43,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-lottedfs.png'),
			imgalt: '탱키패밀리 홍보 사이트 구축',
			prjtitle: '탱키패밀리',
			prjname: '탱키패밀리 홍보 사이트 구축',
			prjyear: '2016',
			pjdate: '06'
		},
		{
			id: 44,
			category: 'etc',
			imgsrc: require('../../static/img/project/genesis-showroom.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/genesis-showroom-thumb.jpg'),
			imgalt: '제네시스 디지털 쇼룸',
			imglayer: 'hmc-digital-showroom',
			prjUrl: 'genesis-shop',
			prjtitle: 'GENESIS Shop in Shop',
			prjname: '제네시스 디지털 쇼룸 GUI 구축',
			prjyear: '2016',
			pjdate: '07'
		},
		{
			id: 45,
			category: 'etc',
			imgsrc: require('../../static/img/project/lotte-food.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lotte-food-thumb.jpg'),
			imgalt: '롯데 프리미엄 푸드마켓',
			imglayer: 'lotte-foodmarket',
			prjUrl: 'premium-food-market',
			prjtitle: 'LOTTE PREMIUM FOOD MARKET',
			prjname: '롯데 프리미엄 푸드마켓 홈페이지 & 모바일 구축',
			prjyear: '2016',
			pjdate: '07'
		},
		{
			id: 46,
			category: 'corporation',
			imgsrc: require('../../static/img/project/pantos.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/pantos-thumb.jpg'),
			imgalt: '판토스',
			imglayer: 'pantos',
			prjUrl: 'pantos',
			prjtitle: 'PANTOS',
			prjname: '판토스 홈페이지 & 모바일 구축',
			prjyear: '2016',
			pjdate: '08'
		},
		{
			id: 47,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-remarkvill.png'),
			imgalt: '리마크빌 홈페이지 구축',
			prjtitle: '리마크빌',
			prjname: '리마크빌 홈페이지 구축',
			prjyear: '2016',
			pjdate: '10'
		},
		{
			id: 48,
			category: 'corporation',
			imgsrc: require('../../static/img/project/glovis-aa.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/glovis-aa-thumb.jpg'),
			imgalt: '현대글로비스 오토옥션',
			imglayer: 'glovisaa',
			prjUrl: 'glovis-aa',
			prjtitle: 'HYUNDAI GLOVIS Autoauction',
			prjname: '현대글로비스 오토옥션 홈페이지, 모바일, 앱 구축',
			prjyear: '2016',
			pjdate: '11'
		},
		{
			id: 49,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-lottemall.png'),
			imgalt: '롯데몰 은평 홍보사이트 구축',
			prjtitle: '롯데몰',
			prjname: '롯데몰 은평 홍보사이트 구축',
			prjyear: '2016',
			pjdate: '12'
		},
		{
			id: 50,
			category: 'system',
			imgsrc: require('../../static/img/project/serveone.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/serveone-thumb.jpg'),
			imgalt: '서브원',
			imglayer: 'serveone',
			prjUrl: 'serveone',
			prjtitle: 'SERVEONE',
			prjname: '서브원 모바일 & 태블릿 구축',
			prjyear: '2016',
			pjdate: '12'
		},
		{
			id: 51,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-innocean.png'),
			imgalt: '이노션 업무포털(이노팟) 개편',
			prjtitle: '이노션',
			prjname: '이노션 업무포털(이노팟) 개편',
			prjyear: '2016',
			pjdate: '12'
		},
		{
			id: 52,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-lgunicharm.png'),
			imgalt: 'LG유니참 브랜드사이트 구축',
			prjtitle: 'LG유니참',
			prjname: 'LG유니참 브랜드사이트 구축',
			prjyear: '2016',
			pjdate: '12'
		},
		{
			id: 53,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-hdmotorgroup.png'),
			imgalt: '현대자동차 Smart Sales Care UI/UX 제작',
			prjtitle: '현대자동차',
			prjname: '현대자동차 Smart Sales Care UI/UX 제작',
			prjyear: '2017',
			pjdate: '04'
		},
		{
			id: 54,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-innocean.png'),
			imgalt: '이노션 사내펀딩 시스템제작',
			prjtitle: '이노션',
			prjname: '이노션 사내펀딩 시스템제작',
			prjyear: '2017',
			pjdate: '05'
		},
		{
			id: 55,
			category: 'system',
			imgsrc: require('../../static/img/project/logo-innocean.png'),
			imgalt: '이노션 해외미디어 예산설정시스템 4.0 (INNO-SMART)구축',
			prjtitle: '이노션',
			prjname: '이노션 해외미디어 예산설정시스템 4.0 (INNO-SMART)구축',
			prjyear: '2017',
			pjdate: '09'
		},
		{
			id: 56,
			category: 'corporation',
			imgsrc: require('../../static/img/project/bio-lgchem.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/bio-lgchem-thumb.jpg'),
			imgalt: 'LG생명과학',
			imglayer: 'bio-lg',
			prjUrl: 'lgchem-life-science',
			prjtitle: 'LG Chem Life Sciences Company',
			prjname: 'LG생명과학 홈페이지 & 모바일 구축',
			prjyear: '2017',
			pjdate: '09'
		},
		{
			id: 57,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-lginnotek.png'),
			imgalt: 'LG이노텍 홈페이지 개편',
			prjtitle: 'LG이노텍',
			prjname: 'LG이노텍 홈페이지 개편',
			prjyear: '2017',
			pjdate: '09'
		},
		{
			id: 58,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/amore-disteady.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/amore-disteady-thumb.jpg'),
			imgalt: '아모레퍼시픽 디스테디몰',
			imglayer: 'd.steady',
			prjUrl: 'd-steady',
			prjtitle: 'D.STEADY Mall',
			prjname: '아모레퍼시픽 디스테디몰 구축',
			prjyear: '2017',
			pjdate: '10'
		},
		{
			id: 59,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-amore.png'),
			imgalt: '글로벌 아모레퍼시픽몰 구축 및 유지보수',
			prjtitle: '글로벌 아모레퍼시픽',
			prjname: '글로벌 아모레퍼시픽몰 구축 및 유지보수',
			prjyear: '2017',
			pjdate: '10'
		},
		{
			id: 60,
			category: 'corporation',
			imgsrc: require('../../static/img/project/logo-mediheal.png'),
			imgalt: '메디힐 중문 웹사이트 개편',
			prjtitle: '메디힐',
			prjname: '메디힐 중문 웹사이트 개편',
			prjyear: '2017',
			pjdate: '10'
		},
		{
			id: 61,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-powertech.png'),
			imgalt: '현대파워텍 노사협의회 앱 제작',
			prjtitle: '현대파워텍',
			prjname: '현대파워텍 노사협의회 앱 제작',
			prjyear: '2017',
			pjdate: '12'
		},
		{
			id: 62,
			category: 'corporation',
			imgsrc: require('../../static/img/project/lg-watersolution.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lg-watersolution-thumb.jpg'),
			imgalt: 'LG Water Solutions',
			imglayer: 'lgwatersolution',
			prjUrl: 'lgwatersolution',
			prjtitle: 'LG Water Solutions',
			prjname: 'LG Water Solutions 홈페이지 구축',
			prjyear: '2017',
			pjdate: '12'
		},
		{
			id: 63,
			category: 'etc',
			imgsrc: require('../../static/img/project/logo-lgchem.png'),
			imgalt: 'LG화학 ESS 파트너 포탈 개편',
			prjtitle: 'LG화학 ESS',
			prjname: 'LG화학 ESS 파트너 포탈 개편',
			prjyear: '2018',
			pjdate: '02'
		},
		{
			id: 64,
			category: 'finance',
			imgsrc: require('../../static/img/project/ing-life.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/ing-life-thumb.jpg'),
			imgalt: 'ING생명 모바일 센터 구축',
			prjUrl: 'ing-life',
			prjtitle: 'ING Life Mobile Center',
			prjname: 'ING생명 모바일 센터 구축',
			prjyear: '2018',
			pjdate: '02'
		},
		{
			id: 65,
			category: 'system',
			imgsrc: require('../../static/img/project/lotte-aa.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lotte-aa-thumb.jpg'),
			imgalt: '롯데오토옥션',
			imglayer: 'lotteaa',
			prjUrl: 'lotte-aa',
			prjtitle: 'LOTTE Autoauction',
			prjname: '롯데오토옥션 홈페이지 & 모바일 구축',
			prjyear: '2018',
			pjdate: '05'
		},
		{
			id: 66,
			category: 'etc',
			imgsrc: require('../../static/img/project/lgchem-history.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lgchem-history-thumb.jpg'),
			imgalt: 'LG화학 역사관',
			imglayer: 'lgchem-history',
			prjUrl: 'lgchem-history',
			prjtitle: 'History of LG Chem',
			prjname: 'LG화학 역사관',
			prjyear: '2018',
			pjdate: '08'
		},
		{
			id: 67,
			category: 'finance',
			imgsrc: require('../../static/img/project/logo-nhlife.png'),
			imgalt: 'NH농협생명 모바일창구 구축',
			prjtitle: 'NH농협생명',
			prjname: 'NH농협생명 모바일창구 구축',
			prjyear: '2018',
			pjdate: '09'
		},
		{
			id: 68,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/logo-amore.png'),
			imgalt: '글로벌 아모레퍼시픽몰 유지보수 ',
			prjtitle: '아모레 퍼시픽',
			prjname: '글로벌 아모레퍼시픽몰 유지보수',
			prjyear: '2018',
			pjdate: '10'
		},
		{
			id: 69,
			category: 'corporation',
			imgsrc: require('../../static/img/project/xeogen-renewal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/xeogen-renewal-thumb.jpg'),
			imgalt: '제오젠 리뉴얼',
			imglayer: 'xeogen',
			prjUrl: 'xeogen',
			prjtitle: 'XEOGEN CI Renewal',
			prjname: '제오젠 CI 및 홈페이지 리뉴얼',
			prjyear: '2018',
			pjdate: '10'
		},
		{
			id: 70,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/hos.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/hos-thumb.jpg'),
			imgalt: '현대자동차그룹 마스터 플랫폼 구축',
			prjUrl: 'hos',
			prjtitle: 'HMC Online Direct Sale Platform',
			prjname: '현대자동차그룹 마스터 플랫폼 구축',
			prjyear: '2018',
			pjdate: '12'
		},
		{
			id: 71,
			category: 'finance',
			imgsrc: require('../../static/img/project/logo-shinhanlife.png'),
			imgalt: '신한 생명 방카 시스템 개편 ',
			prjtitle: '신한생명',
			prjname: '신한 생명 방카 시스템 개편',
			prjyear: '2019',
			pjdate: '06'
		},
		{
			id: 72,
			category: 'system',
			imgsrc: require('../../static/img/project/lotte-tms.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lotte-tms-thumb.jpg'),
			imgalt: '롯데호텔 식음예약시스템 홈페이지, 모바일 구축',
			prjUrl: 'lotte-tms',
			prjtitle: 'LOTTE HOTEL TMS',
			prjname: '롯데호텔 식음예약시스템 홈페이지, 모바일 구축',
			prjyear: '2019',
			pjdate: '03'
		},
		{
			id: 73,
			category: 'corporation',
			imgsrc: require('../../static/img/project/transys.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/transys-thumb.jpg'),
			imgalt: '현대트랜시스 홈페이지 & 모바일 구축',
			prjUrl: 'transys',
			prjtitle: 'HYUNDAI TRANSYS',
			prjname: '현대트랜시스 홈페이지 & 모바일 구축',
			prjyear: '2019',
			pjdate: '03'
		},
		{
			id: 74,
			category: 'travel',
			imgsrc: require('../../static/img/project/yellow-ballon.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/yellow-ballon-thumb.jpg'),
			imgalt: '노랑풍선 홈페이지 & 모바일 구축',
			prjUrl: 'yb-tour',
			prjtitle: 'Yellow Balloon Tour',
			prjname: '노랑풍선 홈페이지 & 모바일 구축',
			prjyear: '2019',
			pjdate: '04'
		},
		{
			id: 75,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/hanssem.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/hanssem-thumb.jpg'),
			imgalt: '한샘 온/오프라인 플랫폼 구축',
			prjUrl: 'hanssem-o4o',
			prjtitle: 'Hanssem.com O4O Platform',
			prjname: '한샘 온/오프라인 플랫폼 구축',
			prjyear: '2019',
			pjdate: '04'
		},
		{
			id: 76,
			category: 'system',
			imgsrc: require('../../static/img/project/discover.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/discover-thumb.jpg'),
			imgalt: '이노션 지식관리 통합시스템 구축',
			prjUrl: 'innocean-discover',
			prjtitle: 'INNOCEAN Discover',
			prjname: '이노션 지식관리 통합시스템 구축',
			prjyear: '2019',
			pjdate: '06'
		},
		{
			id: 77,
			category: 'etc',
			imgsrc: require('../../static/img/project/lg-archive.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lg-archive-thumb.jpg'),
			imgalt: 'LG화학 디지털 아카이브 개편',
			prjUrl: 'lg-archive',
			prjtitle: 'LG Chem Digital Archive',
			prjname: 'LG화학 디지털 아카이브 개편',
			prjyear: '2019',
			pjdate: '09'
		},
		{
			id: 78,
			category: 'finance',
			imgsrc: require('../../static/img/project/db-life.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/db-life-thumb.jpg'),
			imgalt: 'DB생명 모바일사이트 구축',
			prjUrl: 'db-life',
			prjtitle: 'DB Life Mobile Site',
			prjname: 'DB생명 모바일사이트 구축',
			prjyear: '2019',
			pjdate: '09'
		},
		{
			id: 79,
			category: 'finance',
			imgsrc: require('../../static/img/project/kb-card.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/kb-card-thumb.jpg'),
			imgalt: 'KB기업카드 모바일 APP구축',
			prjUrl: 'kb-card',
			prjtitle: 'KB Corporate Card Mobile App',
			prjname: 'KB기업카드 모바일 APP구축',
			prjyear: '2019',
			pjdate: '10'
		},
		{
			id: 80,
			category: 'e-commerce',
			imgsrc: require('../../static/img/project/hos-hk.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/hos-hk-thumb.jpg'),
			imgalt: '현대자동차 인도/홍콩 온라인 판매사이트 개편',
			prjUrl: 'hos-hk',
			prjtitle: 'HMC Online Direct Sale Platform (India/Hongkong)',
			prjname: '현대자동차 인도/홍콩 온라인 판매사이트 개편',
			prjyear: '2019',
			pjdate: '12'
		},
		{
			id: 81,
			category: 'corporation',
			imgsrc: require('../../static/img/project/lg-ess.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lg-ess-thumb.jpg'),
			imgalt: 'LG화학 ESS 개편',
			prjUrl: 'lg-ess',
			prjtitle: 'LG ESS',
			prjname: 'LG화학 ESS 개편',
			prjyear: '2019',
			pjdate: '12'
		},
		{
			id: 82,
			category: 'corporation',
			imgsrc: require('../../static/img/project/ket-renewal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/ket-renewal-thumb.jpg'),
			imgalt: '한국단자홈페이지 구축',
			prjUrl: 'ket-renewal',
			prjtitle: 'Korea Electric Terminal',
			prjname: '한국단자홈페이지 구축',
			prjyear: '2019',
			pjdate: '12'
		},
		{
			id: 83,
			category: 'finance',
			imgsrc: require('../../static/img/project/db-life-smart-phone-sales.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/db-life-smart-phone-sales-thumb.jpg'),
			imgalt: 'DB생명 스마트폰 영업지원시스템',
			prjUrl: 'db-life-smart-phone-sales',
			prjtitle: 'DB Life Smart Phone Sales Support System',
			prjname: 'DB생명 스마트폰 영업지원시스템',
			prjyear: '2020',
			pjdate: '04'
		},
		{
			id: 84,
			category: 'corporation',
			imgsrc: require('../../static/img/project/ezwel-renewal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/ezwel-renewal-thumb.jpg'),
			imgalt: '이지웰 법인 사이트 개편',
			prjUrl: 'ezwel-renewal',
			prjtitle: 'EZWEL Corporate Site Renewal',
			prjname: '이지웰 법인 사이트 개편',
			prjyear: '2020',
			pjdate: '04'
		},
		{
			id: 85,
			category: 'corporation',
			imgsrc: require('../../static/img/project/lg-chem-pr-portal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/lg-chem-pr-portal-thumb.jpg'),
			imgalt: 'LG홍보포탈',
			prjUrl: 'lg-chem-pr-portal',
			prjtitle: 'LG Chem PR Portal',
			prjname: 'LG홍보포탈',
			prjyear: '2020',
			pjdate: '10'
		},
		{
			id: 86,
			category: 'corporation',
			imgsrc: require('../../static/img/project/samsung-svc.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/samsung-svc-thumb.jpg'),
			imgalt: '삼성전자서비스 사이트 개편',
			prjUrl: 'samsung-svc',
			prjtitle: 'SAMSUNG SVC',
			prjname: '삼성전자서비스 사이트 개편',
			prjyear: '2021',
			pjdate: '03'
		},
		{
			id: 87,
			category: 'corporation',
			imgsrc: require('../../static/img/project/siliconwork-renewal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/siliconwork-renewal-thumb.jpg'),
			imgalt: '실리콘웍스 개편',
			prjUrl: 'siliconworks-renewal',
			prjtitle: 'SiliconWorks Renewal',
			prjname: '실리콘웍스 개편',
			prjyear: '2020',
			pjdate: '21'
		},
		{
			id: 88,
			category: 'corporation',
			imgsrc: require('../../static/img/project/ezn-foundation.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/ezn-foundation-thumb.jpg'),
			imgalt: '이지앤 가족복지재단',
			prjUrl: 'ezn-foundation',
			prjtitle: 'EZNFOUNDATION',
			prjname: '이지앤 가족복지재단',
			prjyear: '2021',
			pjdate: '04'
		},
		{
			id: 89,
			category: 'corporation',
			imgsrc: require('../../static/img/project/omron-healthcare.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/omron-healthcare-thumb.jpg'),
			imgalt: '오므론 헬스케어',
			prjUrl: 'omron-healthcare',
			prjtitle: 'Omron Healthcare',
			prjname: '오므론 헬스케어',
			prjyear: '2021',
			pjdate: '03'
		},
		{
			id: 90,
			category: 'corporation',
			imgsrc: require('../../static/img/project/serveone-renewal.jpg'),
			thumbsrc: require('../../static/img/project-detail/pjmove-thumbs/serveone-renewal-thumb.jpg'),
			imgalt: '서브원 리뉴얼',
			prjUrl: 'serveone-renewal',
			prjtitle: 'Serveone Renewal',
			prjname: '서브원 리뉴얼',
			prjyear: '2021',
			pjdate: '05'
		},

{
id: 91,
category: 'corporation',
imgsrc: require('../../static/img/project/lxpantos-renewal2022.jpg'),
thumbsrc: '',
imgalt: 'LX판토스 홈페이지 개편',
prjUrl: '', 
prjtitle: 'LX PANTOS Renewal',
prjname: 'LX판토스 홈페이지 개편',
prjyear: '2022',
pjdate: '10'
},

{
id: 92,
category: 'e-commerce',
imgsrc: require('../../static/img/project/atomy-renewal.jpg'),
thumbsrc: '',
imgalt: '애터미쇼핑몰 재구축 UX-파트',
prjUrl: '', 
prjtitle: '',
prjname: '애터미쇼핑몰 재구축 UX-파트',
prjyear: '2022',
pjdate: '12'
},

{
id: 93,
category: 'finance',
imgsrc: require('../../static/img/project/shinhanbank-edusol.jpg'),
thumbsrc: '',
imgalt: '신한은행 고령자 모바일앱 사용교육 콘텐츠 제작',
prjUrl: '', 
prjtitle: '',
prjname: '신한은행 고령자 모바일앱 사용교육 콘텐츠 제작',
prjyear: '2023',
pjdate: '01'
},

{
id: 94,
category: 'e-commerce',
imgsrc: require('../../static/img/project/samsungwelstory.jpg'),
thumbsrc: '',
imgalt: '삼성웰스토리 이커머스 재구축 프로젝트',
prjUrl: '', 
prjtitle: '',
prjname: '삼성웰스토리 이커머스 재구축 프로젝트',
prjyear: '2023',
pjdate: '01'
},

{
id: 95,
category: 'system',
imgsrc: require('../../static/img/project/autoever-ecampus.jpg'),
thumbsrc: '',
imgalt: '현대오토에버 그룹사 E-CAMPUS 시스템 개선',
prjUrl: '', 
prjtitle: '',
prjname: '현대오토에버 그룹사 E-CAMPUS 시스템 개선',
prjyear: '2023',
pjdate: '03'
},

{
id: 96,
category: 'corporation',
imgsrc: require('../../static/img/project/lxsemicon-business.jpg'),
thumbsrc: '',
imgalt: 'LX세미콘 비즈니스 포털 기능개선',
prjUrl: '', 
prjtitle: '',
prjname: 'LX세미콘 비즈니스 포털 기능개선',
prjyear: '2023',
pjdate: '03'
},

{
id: 97,
category: 'corporation',
imgsrc: require('../../static/img/project/shinsegae-department.jpg'),
thumbsrc: '',
imgalt: '신세계백화점 디지털스토어 구축사업',
prjUrl: '', 
prjtitle: '',
prjname: '신세계백화점 디지털스토어 구축사업',
prjyear: '2023',
pjdate: '04'
},

{
id: 98,
category: 'corporation',
imgsrc: require('../../static/img/project/lxventures.jpg'),
thumbsrc: '',
imgalt: 'LX벤처스 홈페이지 구축',
prjUrl: '', 
prjtitle: '',
prjname: 'LX벤처스 홈페이지 구축',
prjyear: '2023',
pjdate: '07'
},

{
id: 99,
category: 'finance',
imgsrc: require('../../static/img/project/kookminbank-archive.jpg'),
thumbsrc: '',
imgalt: 'KB국민은행 디지털기록관 사업',
prjUrl: '', 
prjtitle: '',
prjname: 'KB국민은행 디지털기록관 사업',
prjyear: '2023',
pjdate: '07'
},

{
id: 100,
category: 'finance',
imgsrc: require('../../static/img/project/shinhanbank-sign.jpg'),
thumbsrc: '',
imgalt: '신한은행 클라우드형 신한SIGN 서비스 구축',
prjUrl: '', 
prjtitle: '',
prjname: '신한은행 클라우드형 신한SIGN 서비스 구축',
prjyear: '2023',
pjdate: '11'
},

{
id: 101,
category: 'corporation',
imgsrc: require('../../static/img/project/sbiz-bigdata.jpg'),
thumbsrc: '',
imgalt: '소상공인 개방형 빅데이터 플랫폼 구축 기술지원',
prjUrl: '', 
prjtitle: '',
prjname: '소상공인 개방형 빅데이터 플랫폼 구축 기술지원',
prjyear: '2024',
pjdate: '01'
},

{
id: 102,
category: 'finance',
imgsrc: require('../../static/img/project/heungkukfire-direct-car.jpg'),
thumbsrc: '',
imgalt: '흥국화재 다이렉트 자동차보험',
prjUrl: '', 
prjtitle: '',
prjname: '흥국화재 다이렉트 자동차보험',
prjyear: '2024',
pjdate: '05'
},

{
id: 103,
category: 'system',
imgsrc: require('../../static/img/project/hyundai-kefico-ev-charger.jpg'),
thumbsrc: '',
imgalt: '현대케피코 EV충전기 관리관재 시스템 추가개발',
prjUrl: '', 
prjtitle: '',
prjname: '현대케피코 EV충전기 관리관재 시스템 추가개발',
prjyear: '2024',
pjdate: '08'
},

{
id: 104,
category: 'travel',
imgsrc: require('../../static/img/project/parnashotel.jpg'),
thumbsrc: '',
imgalt: '파라나스 호텔 홈페이지 유지보수 (~2025.01)',
prjUrl: '', 
prjtitle: '',
prjname: '파라나스 호텔 홈페이지 유지보수 (~2025.01)',
prjyear: '2024',
pjdate: '12'
},

{
id: 105,
category: 'corporation',
imgsrc: require('../../static/img/project/lxsemicon-renewal2025.jpg'),
thumbsrc: '',
imgalt: 'LX세미콘 홈페이지 개편',
prjUrl: '', 
prjtitle: '',
prjname: 'LX세미콘 홈페이지 개편',
prjyear: '2025',
pjdate: '01'
},

{
id: 106,
category: 'corporation',
imgsrc: require('../../static/img/project/ket-renewal2025.jpg'),
thumbsrc: '',
imgalt: '한국단자 홈페이지 개편',
prjUrl: '', 
prjtitle: '',
prjname: '한국단자 홈페이지 개편',
prjyear: '2025',
pjdate: '08'
},

{
id: 107,
category: 'corporation',
imgsrc: require('../../static/img/project/hyundai-transys-renewal2025.jpg'),
imgalt: '현대트랜시스 홈페이지 개편',
prjUrl: '', 
prjname: '현대트랜시스 홈페이지 개편',
prjyear: '2025',
pjdate: '10'
}

	],
	partners: [
		{
			id: 1,
			imgsrc: require('../../static/img/partner/hmc.gif'),
			imgalt: '현대자동차그룹',
		},
		{
			id: 2,
			imgsrc: require('../../static/img/partner/hyundai-motors.gif'),
			imgalt: '현대자동차',
		},
		{
			id: 3,
			imgsrc: require('../../static/img/partner/amore-pacific.gif'),
			imgalt: '아모레퍼시픽',
		},
		{
			id: 4,
			imgsrc: require('../../static/img/partner/cheil.gif'),
			imgalt: '제일기획',
		},
		{
			id: 5,
			imgsrc: require('../../static/img/partner/disney.gif'),
			imgalt: 'The Walt Disney Company',
		},
		{
			id: 6,
			imgsrc: require('../../static/img/partner/eduwill.gif'),
			imgalt: '에듀윌',
		},
		{
			id: 7,
			imgsrc: require('../../static/img/partner/fujitsu.gif'),
			imgalt: '후지쯔',
		},
		{
			id: 8,
			imgsrc: require('../../static/img/partner/glovis.gif'),
			imgalt: '현대글로비스',
		},
		{
			id: 9,
			imgsrc: require('../../static/img/partner/green-umbrella.gif'),
			imgalt: '초록우산 어린이재단',
		},
		{
			id: 10,
			imgsrc: require('../../static/img/partner/haevichi.gif'),
			imgalt: '해비치 리조트',
		},
		{
			id: 11,
			imgsrc: require('../../static/img/partner/hyudai-departmentstore.gif'),
			imgalt: '현대백화점',
		},
		{
			id: 12,
			imgsrc: require('../../static/img/partner/hyunadi-autoever.gif'),
			imgalt: '현대 오토에버',
		},
		{
			id: 13,
			imgsrc: require('../../static/img/partner/hyundai-captital.gif'),
			imgalt: '현대캐피탈',
		},
		{
			id: 14,
			imgsrc: require('../../static/img/partner/hyundai-card.gif'),
			imgalt: '현대카드',
		},
		{
			id: 15,
			imgsrc: require('../../static/img/partner/hyundai-life.gif'),
			imgalt: '현대해상',
		},
		{
			id: 16,
			imgsrc: require('../../static/img/partner/hyundai-rotem.gif'),
			imgalt: '현대로템',
		},
		{
			id: 17,
			imgsrc: require('../../static/img/partner/hyundai-steel.gif'),
			imgalt: '현대제철',
		},
		{
			id: 18,
			imgsrc: require('../../static/img/partner/ibm.gif'),
			imgalt: 'IBM',
		},
		{
			id: 19,
			imgsrc: require('../../static/img/partner/ing.gif'),
			imgalt: 'ING',
		},
		{
			id: 20,
			imgsrc: require('../../static/img/partner/innocean.gif'),
			imgalt: '이노션',
		},
		{
			id: 21,
			imgsrc: require('../../static/img/partner/kia.gif'),
			imgalt: '기아자동차',
		},
		{
			id: 22,
			imgsrc: require('../../static/img/partner/kt.gif'),
			imgalt: 'KT',
		},
		{
			id: 23,
			imgsrc: require('../../static/img/partner/lgchem.gif'),
			imgalt: 'LG화학',
		},
		{
			id: 24,
			imgsrc: require('../../static/img/partner/lguplus.gif'),
			imgalt: 'LG U+',
		},
		{
			id: 25,
			imgsrc: require('../../static/img/partner/lotte-rental.gif'),
			imgalt: '롯데렌탈',
		},
		{
			id: 26,
			imgsrc: require('../../static/img/partner/lotte-autoauction.gif'),
			imgalt: '롯데오토옥션',
		},
		{
			id: 27,
			imgsrc: require('../../static/img/partner/lotte-dutyfree.gif'),
			imgalt: '롯데면세점',
		},
		{
			id: 28,
			imgsrc: require('../../static/img/partner/lotte-shopping.gif'),
			imgalt: '롯데홈쇼핑',
		},
		{
			id: 29,
			imgsrc: require('../../static/img/partner/merits.gif'),
			imgalt: '메리츠 화재',
		},
		{
			id: 30,
			imgsrc: require('../../static/img/partner/nexon.gif'),
			imgalt: '넥슨',
		},
		{
			id: 31,
			imgsrc: require('../../static/img/partner/nh.gif'),
			imgalt: 'NH농협생명',
		},
		{
			id: 32,
			imgsrc: require('../../static/img/partner/nike.gif'),
			imgalt: '나이키',
		},
		{
			id: 33,
			imgsrc: require('../../static/img/partner/overdigm.gif'),
			imgalt: '오버다임',
		},
		{
			id: 34,
			imgsrc: require('../../static/img/partner/pantos.gif'),
			imgalt: '판토스',
		},
		{
			id: 35,
			imgsrc: require('../../static/img/partner/samsung.gif'),
			imgalt: '삼성',
		},
		{
			id: 36,
			imgsrc: require('../../static/img/partner/samsung-sds.gif'),
			imgalt: '삼성 SDS',
		},
		{
			id: 37,
			imgsrc: require('../../static/img/partner/shilla-ipark.gif'),
			imgalt: '신라아이파크면세점',
		},
		{
			id: 38,
			imgsrc: require('../../static/img/partner/shinhan-life.gif'),
			imgalt: '신한생명',
		},
		{
			id: 39,
			imgsrc: require('../../static/img/partner/sk-comms.gif'),
			imgalt: 'SK Communications',
		},
		{
			id: 40,
			imgsrc: require('../../static/img/partner/skt.gif'),
			imgalt: 'SK Telecome',
		},
		{
			id: 41,
			imgsrc: require('../../static/img/partner/sony.gif'),
			imgalt: 'SONY',
		},
		{
			id: 42,
			imgsrc: require('../../static/img/partner/t-mobile.gif'),
			imgalt: 'T Mobile',
		},
		{
			id: 43,
			imgsrc: require('../../static/img/partner/vertizon.gif'),
			imgalt: 'Verizon',
		},
		{
			id: 44,
			imgsrc: require('../../static/img/partner/yellow-balloon.gif'),
			imgalt: '노란풍선 여행사',
		},
		{
			id: 45,
			imgsrc: require('../../static/img/partner/pasteur.gif'),
			imgalt: '파스퇴르',
		},
		{
			id: 46,
			imgsrc: require('../../static/img/partner/asan-hospital.gif'),
			imgalt: '서울아산병원',
		},
		{
			id: 47,
			imgsrc: require('../../static/img/partner/powertech.gif'),
			imgalt: '현대파워텍',
		},
		{
			id: 48,
			imgsrc: require('../../static/img/partner/lge.gif'),
			imgalt: 'LG전자',
		},
	],
	bsd: [
		{
			index: 1,
			category: 'presentation',
			ptUrl: 'blue-house',
			thumbTitle: '청와대 <br>외교안보 비전과 전략',
			thumbImg: require('../../static/img/visual-marketing/blue-house.jpg'),
			ViewTitle: '청와대 외교안보 비전과 전략 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/blue-house.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 2,
			category: 'presentation',
			ptUrl: 'hanhwa-chemical',
			thumbTitle: '한화케미칼 <br>회사소개 홍보',
			thumbImg: require('../../static/img/visual-marketing/hanhwa-chemical.jpg'),
			ViewTitle: '한화케미칼 회사소개 홍보 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/hanhwa-chemical.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 3,
			category: 'proposal',
			ptUrl: 'ministry-of-justice-foreigners',
			thumbTitle: '법무부 <br>외국인종합안내센터',
			thumbImg: require('../../static/img/visual-marketing/ministry-of-justice-foreigners.jpg'),
			ViewTitle: '법무부 외국인종합안내센터 다국어 콜센터 경쟁입찰 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/ministry-of-justice-foreigners.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 4,
			category: 'presentation',
			ptUrl: 'nh-university-hr-system',
			thumbTitle: '농협대학교 <br>인사제도 개선방안',
			thumbImg: require('../../static/img/visual-marketing/nh-university-hr-system.jpg'),
			ViewTitle: '농협대학교 인사제도 개선방안 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/nh-university-hr-system.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 5,
			category: 'presentation',
			ptUrl: 'mando-pr',
			thumbTitle: 'MANDO <br>회사소개 홍보',
			thumbImg: require('../../static/img/visual-marketing/mando-pr.jpg'),
			ViewTitle: 'MANDO 회사소개 홍보 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/mando-pr.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 6,
			category: 'presentation',
			ptUrl: 'oca-report',
			thumbTitle: '아시아올림픽평의회 <br>국제부 보고회',
			thumbImg: require('../../static/img/visual-marketing/oca-report.jpg'),
			ViewTitle: '아시아올림픽평의회(OCA) 국제부 보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/oca-report.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 7,
			category: 'presentation',
			ptUrl: 'ksa-certification-system',
			thumbTitle: '한국표준협회 <br>KS 인증제도',
			thumbImg: require('../../static/img/visual-marketing/ksa-certification-system.jpg'),
			ViewTitle: '한국표준협회 KS 인증제도 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ksa-certification-system.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 8,
			category: 'presentation',
			ptUrl: 'oca-environment-report',
			thumbTitle: '아시아올림픽평의회 <br>환경위원회 보고회',
			thumbImg: require('../../static/img/visual-marketing/oca-environment-report.jpg'),
			ViewTitle: '아시아올림픽평의회(OCA) 환경위원회 보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/oca-environment-report.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 9,
			category: 'presentation',
			ptUrl: 'oca-culture-report',
			thumbTitle: '아시아올림픽평의회 <br>문화위원회 보고회',
			thumbImg: require('../../static/img/visual-marketing/oca-culture-report.jpg'),
			ViewTitle: '아시아올림픽평의회(OCA) 문화위원회 보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/oca-culture-report.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 10,
			category: 'presentation',
			ptUrl: 'incheon-ag-tech',
			thumbTitle: '인천아시아경기대회 <br>기술대표회의',
			thumbImg: require('../../static/img/visual-marketing/incheon-ag-tech.jpg'),
			ViewTitle: '인천아시아경기대회 기술대표회의 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-ag-tech.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 11,
			category: 'presentation',
			ptUrl: 'kca-innovation',
			thumbTitle: '한국방송통신전파진흥원 <br>신청사 개원식',
			thumbImg: require('../../static/img/visual-marketing/kca-innovation.jpg'),
			ViewTitle: '한국방송통신전파진흥원 빛가람혁신도시 신청사 개원 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/kca-innovation.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 12,
			category: 'presentation',
			ptUrl: 'ongjin-pt',
			thumbTitle: '옹진군청 <br>주요업무 보고',
			thumbImg: require('../../static/img/visual-marketing/ongjin-pt.jpg'),
			ViewTitle: '옹진군청 주요업무 보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ongjin-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 13,
			category: 'proposal',
			ptUrl: 'kepco-cs',
			thumbTitle: '한국전력공사 <br>고객센터 경쟁입찰 제안',
			thumbImg: require('../../static/img/visual-marketing/kepco-cs.jpg'),
			ViewTitle: '한국전력공사 고객센터 경쟁입찰 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/kepco-cs.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 14,
			category: 'presentation',
			ptUrl: 'incheon-ag-sucess',
			thumbTitle: '인천아시아경기대회 <br>대회성공의 조건',
			thumbImg: require('../../static/img/visual-marketing/incheon-ag-sucess.jpg'),
			ViewTitle: '인천아시아경기대회 대회성공의 조건 AUTO PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-ag-sucess.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 15,
			category: 'presentation',
			ptUrl: 'incheon-ad-auto-pt',
			thumbTitle: '인천아시아경기대회 <br>아름다운 승복',
			thumbImg: require('../../static/img/visual-marketing/incheon-ad-auto-pt.jpg'),
			ViewTitle: '인천아시아경기대회 <br>아름다운 승복, 승자의 배려 AUTO PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-ad-auto-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 16,
			category: 'presentation',
			ptUrl: 'nps-pt',
			thumbTitle: '국민연금공단 <br>수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/nps-pt.jpg'),
			ViewTitle: '국민연금공단 수주제안 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/nps-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 17,
			category: 'presentation',
			ptUrl: 'bmw-cic-lrp',
			thumbTitle: 'BMW <br>CIC LRP Business',
			thumbImg: require('../../static/img/visual-marketing/bmw-cic-lrp.jpg'),
			ViewTitle: 'BMW CIC LRP Business 수주제안 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/bmw-cic-lrp.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 18,
			category: 'proposal',
			ptUrl: 'seoul-120-pt',
			thumbTitle: '서울시 120다산콜센터 <br>경쟁입찰 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/seoul-120-pt.jpg'),
			ViewTitle: '서울시 120다산콜센터 경쟁입찰 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/seoul-120-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 19,
			category: 'presentation',
			ptUrl: 'incheon-paralympic-pt',
			thumbTitle: '인천장애인아시아경기대회 <br>성과보고',
			thumbImg: require('../../static/img/visual-marketing/incheon-paralympic-pt.jpg'),
			ViewTitle: '인천장애인아시아경기대회 성과보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-paralympic-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 20,
			category: 'presentation',
			ptUrl: 'aia-cs-pt',
			thumbTitle: 'AIA생명 통합콜센터 <br>경쟁입찰',
			thumbImg: require('../../static/img/visual-marketing/aia-cs-pt.jpg'),
			ViewTitle: 'AIA생명 통합콜센터 경쟁입찰 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/aia-cs-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 21,
			category: 'presentation',
			ptUrl: 'incheon-investment',
			thumbTitle: '인천광역시 <br>투자유치 전략',
			thumbImg: require('../../static/img/visual-marketing/incheon-investment.jpg'),
			ViewTitle: '인천광역시 투자유치 전략 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-investment.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 22,
			category: 'presentation',
			ptUrl: 'incheon-ag-final-report',
			thumbTitle: '인천아시아경기대회 <br>Final Report',
			thumbImg: require('../../static/img/visual-marketing/incheon-ag-final-report.jpg'),
			ViewTitle: '인천아시아경기대회 Final Report PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/incheon-ag-final-report.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 23,
			category: 'proposal',
			ptUrl: 'asiana-cs-competition',
			thumbTitle: '아시아나항공 <br>고객센터 경쟁입찰 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/asiana-cs-competition.jpg'),
			ViewTitle: '아시아나항공 고객센터 경쟁입찰 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/asiana-cs-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 24,
			category: 'presentation',
			ptUrl: 'gcon-big-pie',
			thumbTitle: '경기콘텐츠진흥원 <br>빅파이추진단 VISION 선포식',
			thumbImg: require('../../static/img/visual-marketing/gcon-big-pie.jpg'),
			ViewTitle: '경기콘텐츠진흥원 빅파이추진단 VISION 선포식 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/gcon-big-pie.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 25,
			category: 'proposal',
			ptUrl: 'grac-oidd-competition-proposal',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/grac-oidd-competition-proposal.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 제안서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/grac-oidd-competition-proposal.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 26,
			category: 'presentation',
			ptUrl: 'grac-oidd-competition-pt',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 PT 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/grac-oidd-competition-pt.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/grac-oidd-competition-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 27,
			category: 'presentation',
			ptUrl: 'janghyung-labor-management',
			thumbTitle: '장형기업 <br>노사문화 우수기업 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/janghyung-labor-management.jpg'),
			ViewTitle: '장형기업 노사문화 우수기업 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/janghyung-labor-management.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 28,
			category: 'presentation',
			ptUrl: 'kosha-risk assessment-pt',
			thumbTitle: '안전보건공단 <br>위험성평가 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/kosha-risk assessment-pt.jpg'),
			ViewTitle: '안전보건공단 위험성평가 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/kosha-risk assessment-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 29,
			category: 'presentation',
			ptUrl: 'kakao-cs',
			thumbTitle: '카카오뱅크 <br>고객센터 수주제안',
			thumbImg: require('../../static/img/visual-marketing/kakao-cs.jpg'),
			ViewTitle: '카카오뱅크 고객센터 수주제안 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/kakao-cs.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 30,
			category: 'proposal',
			ptUrl: 'bluecompass-intro',
			thumbTitle: '파란나침반 <br>회사소개서 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/bluecompass-intro.jpg'),
			ViewTitle: '파란나침반 회사소개서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/bluecompass-intro.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 31,
			category: 'presentation',
			ptUrl: 'ktcu-cs-competition',
			thumbTitle: '한국교직원공제회 <br>보험콜센터 경쟁입찰 PT',
			thumbImg: require('../../static/img/visual-marketing/ktcu-cs-competition.jpg'),
			ViewTitle: '한국교직원공제회 보험콜센터 경쟁입찰 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ktcu-cs-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 32,
			category: 'proposal',
			ptUrl: 'ktcu-cs-competition-proposal',
			thumbTitle: '한국교직원공제회 <br>보험콜센터 경쟁입찰 제안',
			thumbImg: require('../../static/img/visual-marketing/ktcu-cs-competition-proposal.jpg'),
			ViewTitle: '한국교직원공제회 보험콜센터 경쟁입찰 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ktcu-cs-competition-proposal.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 33,
			category: 'proposal',
			ptUrl: 'sunwoospring-csr',
			thumbTitle: '선우정밀 <br>CSR 컨설팅 제안',
			thumbImg: require('../../static/img/visual-marketing/sunwoospring-csr.jpg'),
			ViewTitle: '선우정밀 CSR 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/sunwoospring-csr.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 34,
			category: 'proposal',
			ptUrl: 'public-sewage-treatment-facility-consulting',
			thumbTitle: '안산시 공공하수처리시설 <br>경쟁입찰 컨설팅 제안',
			thumbImg: require('../../static/img/visual-marketing/public-sewage-treatment-facility-consulting.jpg'),
			ViewTitle: '안산시 공공하수처리시설 관리대행 경쟁입찰 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/public-sewage-treatment-facility-consulting.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 35,
			category: 'presentation',
			ptUrl: 'donga-stillen',
			thumbTitle: '동아제약 <br>Stillen/Stillen 2X 제품 소개',
			thumbImg: require('../../static/img/visual-marketing/donga-stillen.jpg'),
			ViewTitle: '동아제약 Stillen/Stillen 2X 제품 소개 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/donga-stillen.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 36,
			category: 'proposal',
			ptUrl: 'kumc-competition',
			thumbTitle: '고려대학교 안암병원 <br>수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/kumc-competition.jpg'),
			ViewTitle: '고려대학교 안암병원 수주제안 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/kumc-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 37,
			category: 'presentation',
			ptUrl: 'hwenc-algeria',
			thumbTitle: '한화건설 <br>알제리 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/hwenc-algeria.jpg'),
			ViewTitle: '한화건설 알제리 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/hwenc-algeria.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 38,
			category: 'presentation',
			ptUrl: 'posco-safety-consulting',
			thumbTitle: '포스코건설 <br>안전보건 우수사례 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/posco-safety-consulting.jpg'),
			ViewTitle: '포스코건설 안전보건 우수사례 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/posco-safety-consulting.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 39,
			category: 'presentation',
			ptUrl: 'keco-vinyl',
			thumbTitle: '한국환경공단 <br>재활용처리시설 경쟁입찰 PT',
			thumbImg: require('../../static/img/visual-marketing/keco-vinyl.jpg'),
			ViewTitle: '한국환경공단 폐비닐 재활용처리시설 위탁운영 경쟁입찰 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/keco-vinyl.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 40,
			category: 'proposal',
			ptUrl: 'keco-recycle',
			thumbTitle: '한국환경공단 <br>재활용처리시설 경쟁입찰 제안',
			thumbImg: require('../../static/img/visual-marketing/keco-recycle.jpg'),
			ViewTitle: '한국환경공단 폐비닐 재활용처리시설 위탁운영 경쟁입찰 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/keco-recycle.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 41,
			category: 'proposal',
			ptUrl: 'ibs-fm-management',
			thumbTitle: 'IBS <br>FM관리 수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/ibs-fm-management.jpg'),
			ViewTitle: 'IBS FM관리 수주제안 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/ibs-fm-management.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 42,
			category: 'proposal',
			ptUrl: 'loca-competition',
			thumbTitle: '롯데카드 <br>수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/loca-competition.jpg'),
			ViewTitle: '롯데카드 수주제안 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/loca-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 43,
			category: 'proposal',
			ptUrl: 'volkswagen-competition',
			thumbTitle: '폭스바겐 <br>수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/volkswagen-competition.jpg'),
			ViewTitle: '폭스바겐 수주제안 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/volkswagen-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 44,
			category: 'proposal',
			ptUrl: 'klid',
			thumbTitle: '한국지역정보개발원 <br>표준기록관리시스템 통합 유지관리',
			thumbImg: require('../../static/img/visual-marketing/klid.jpg'),
			ViewTitle: '한국지역정보개발원 표준기록관리시스템 통합 유지관리 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/klid.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 45,
			category: 'presentation',
			ptUrl: 'nhis-cs',
			thumbTitle: '국민건강보험 <br>본부고객센터 위탁운영',
			thumbImg: require('../../static/img/visual-marketing/nhis-cs.jpg'),
			ViewTitle: '국민건강보험 본부고객센터 위탁운영 제안 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/nhis-cs.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 46,
			category: 'presentation',
			ptUrl: 'sunwoo-safety-leadership',
			thumbTitle: '선우정밀 <br>한화 안전리더십',
			thumbImg: require('../../static/img/visual-marketing/sunwoo-safety-leadership.jpg'),
			ViewTitle: '선우정밀 - 한화 안전리더십 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/sunwoo-safety-leadership.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 47,
			category: 'proposal',
			ptUrl: 'kdic-competition',
			thumbTitle: '예금보험공사 <br>수주제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/kdic-competition.jpg'),
			ViewTitle: '예금보험공사 케이알앤씨 채권 관리 및 추심업무 수탁자 선정 제안서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/kdic-competition.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 48,
			category: 'presentation',
			ptUrl: 'sev-eye-severance',
			thumbTitle: '세브란스 의안과 <br>신개념 원천기술개발 사업',
			thumbImg: require('../../static/img/visual-marketing/sev-eye-severance.jpg'),
			ViewTitle: '세브란스 의안과 차세대 신개념 의료기기 원천기술개발 사업 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/sev-eye-severance.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 49,
			category: 'proposal',
			ptUrl: 'bifc-Integrated-management',
			thumbTitle: 'BIFC <br>통합관리 용역 제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/bifc-Integrated-management.jpg'),
			ViewTitle: 'BIFC 업무 및 판매시설 통합관리 용역 제안서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/bifc-Integrated-management.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 50,
			category: 'presentation',
			ptUrl: 'uiam-lake-sightseeing-cruise',
			thumbTitle: '의암호 관광유람선 <br>운항사업 제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/uiam-lake-sightseeing-cruise.jpg'),
			ViewTitle: '의암호 관광유람선 운항사업 제안 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/uiam-lake-sightseeing-cruise.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 51,
			category: 'presentation',
			ptUrl: 'samcheok-international-conference',
			thumbTitle: '삼척시청 <br>국제컨퍼런스 발표 및 홍보',
			thumbImg: require('../../static/img/visual-marketing/samcheok-international-conference.jpg'),
			ViewTitle: '삼척시청 국제컨퍼런스 발표 및 홍보용 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/samcheok-international-conference.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 52,
			category: 'presentation',
			ptUrl: 'seoul-square-ibs-ssq-renovation',
			thumbTitle: '서울스퀘어 <br>IBS SSQ Renovation',
			thumbImg: require('../../static/img/visual-marketing/seoul-square-ibs-ssq-renovation.jpg'),
			ViewTitle: '서울스퀘어 IBS SSQ Renovation PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/seoul-square-ibs-ssq-renovation.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 53,
			category: 'presentation',
			ptUrl: 'yesan-convergence-support-project',
			thumbTitle: '예산군 <br>융복합지원사업 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/yesan-convergence-support-project.jpg'),
			ViewTitle: '예산군 융복합지원사업 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/yesan-convergence-support-project.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 54,
			category: 'presentation',
			ptUrl: 'asan-dc1',
			thumbTitle: '아산DC1 <br>공업용수 공급시설 운영사업',
			thumbImg: require('../../static/img/visual-marketing/asan-dc1.jpg'),
			ViewTitle: '아산DC1 공업용수 공급시설 민간위탁 운영사업 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/asan-dc1.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 55,
			category: 'proposal',
			ptUrl: 'grac-oidd-competition-proposal02',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/grac-oidd-competition-proposal02.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 제안서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/grac-oidd-competition-proposal02.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 56,
			category: 'presentation',
			ptUrl: 'grac-oidd-competition-pt02',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 PT 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/grac-oidd-competition-pt02.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 요약본 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/grac-oidd-competition-pt02.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 57,
			category: 'proposal',
			ptUrl: 'volkswagen-cs-education',
			thumbTitle: '폭스바겐 <br>CS교육 결과 보고서 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/volkswagen-cs-education.jpg'),
			ViewTitle: '폭스바겐 CS교육 결과 보고서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/volkswagen-cs-education.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 58,
			category: 'presentation',
			ptUrl: 'kepco-icqcc',
			thumbTitle: '한국전력 <br>국제품질분임조경진대회 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/kepco-icqcc.jpg'),
			ViewTitle: '한국전력 국제품질분임조경진대회 ICQCC PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/kepco-icqcc.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 59,
			category: 'presentation',
			ptUrl: 'jiat-innovation',
			thumbTitle: '자동차융합기술원 <br>상용차산업 혁신성장 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/jiat-innovation.jpg'),
			ViewTitle: '자동차융합기술원 상용차산업 혁신성장 PT 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/jiat-innovation.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 60,
			category: 'presentation',
			ptUrl: 'ku-prime',
			thumbTitle: '건국대학교 <br>프라임사업단 성과보고',
			thumbImg: require('../../static/img/visual-marketing/ku-prime.jpg'),
			ViewTitle: '건국대학교 프라임사업단 성과보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ku-prime.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 61,
			category: 'proposal',
			ptUrl: 'korea-cash-payment',
			thumbTitle: '한국현금결제 <br>B2B 현금결제시스템 바로패스',
			thumbImg: require('../../static/img/visual-marketing/korea-cash-payment.jpg'),
			ViewTitle: '한국현금결제 B2B 현금결제시스템 바로패스 소개 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/korea-cash-payment.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 62,
			category: 'proposal',
			ptUrl: 'kunjin-motors',
			thumbTitle: '군진자동차 <br>회사 소개 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/kunjin-motors.jpg'),
			ViewTitle: '군진자동차 회사 소개 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/kunjin-motors.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 63,
			category: 'presentation',
			ptUrl: 'luther-univ',
			thumbTitle: '루터대학교 <br>수도권역성과포럼',
			thumbImg: require('../../static/img/visual-marketing/luther-univ.jpg'),
			ViewTitle: '루터대학교 수도권역성과포럼 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/luther-univ.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 64,
			category: 'presentation',
			ptUrl: 'ku-csp',
			thumbTitle: '건국대학교 <br>대학혁신지원사업',
			thumbImg: require('../../static/img/visual-marketing/ku-csp.jpg'),
			ViewTitle: '건국대학교 대학혁신지원사업 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ku-csp.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 65,
			category: 'presentation',
			ptUrl: 'jeonbuk-safety-belt',
			thumbTitle: '전라북도 <br>고용안정 Safety Belt 구축사업',
			thumbImg: require('../../static/img/visual-marketing/jeonbuk-safety-belt.jpg'),
			ViewTitle: '전라북도 상용차산업 위기대응 고용안정 Safety Belt 구축 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/jeonbuk-safety-belt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 66,
			category: 'proposal',
			ptUrl: 'severance-design',
			thumbTitle: '세브란스병원 <br>수주제안 디자인',
			thumbImg: require('../../static/img/visual-marketing/severance-design.jpg'),
			ViewTitle: '세브란스병원 수주제안 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/severance-design.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 67,
			category: 'presentation',
			ptUrl: 'jeonbuk-innovation',
			thumbTitle: '전라북도 <br>지역일자리거점 혁신계획',
			thumbImg: require('../../static/img/visual-marketing/jeonbuk-innovation.jpg'),
			ViewTitle: '전라북도 산업단지 중심의 지역일자리거점 혁신계획 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/jeonbuk-innovation.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 68,
			category: 'presentation',
			ptUrl: 'ku-education',
			thumbTitle: '건국대학교 <br>교육성과관리센터 업무성과보고',
			thumbImg: require('../../static/img/visual-marketing/ku-education.jpg'),
			ViewTitle: '건국대학교 교육성과관리센터 업무성과보고 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ku-education.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 69,
			category: 'presentation',
			ptUrl: 'jiat-innovation02',
			thumbTitle: '자동차융합기술원 <br>상용차산업 혁신성장',
			thumbImg: require('../../static/img/visual-marketing/jiat-innovation02.jpg'),
			ViewTitle: '자동차융합기술원 상용차산업 혁신성장 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/jiat-innovation02.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 70,
			category: 'proposal',
			ptUrl: 'game-rating-administration-committee',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 제안 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/game-rating-administration-committee.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 제안서 컨설팅 및 디자인',
			ViewCategory: 'Proposal Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/game-rating-administration-committee.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 71,
			category: 'presentation',
			ptUrl: 'game-rating-administration-committee-oidd',
			thumbTitle: '게임물관리위원회 <br>OIDD 경쟁입찰 PT 컨설팅',
			thumbImg: require('../../static/img/visual-marketing/game-rating-administration-committee-oidd.jpg'),
			ViewTitle: '게임물관리위원회 OIDD 경쟁입찰 요약본 컨설팅 및 디자인',
			ViewCategory: 'Presentation Design, Consulting',
			ViewImg: require('../../static/img/visual-marketing-detail/game-rating-administration-committee-oidd.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 72,
			category: 'proposal',
			ptUrl: 'mofa-csp',
			thumbTitle: '외교부 해외 긴급의료 이후송 및 보험지원 서비스 제안',
			thumbImg: require('../../static/img/visual-marketing/mofa-csp.jpg'),
			ViewTitle: '외교부 해외 긴급의료 이후송 및 보험지원 서비스 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/mofa-csp.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 73,
			category: 'presentation',
			ptUrl: 'kcli-pt',
			thumbTitle: '한국고용노동교육원 <br>청소년진로프로그램',
			thumbImg: require('../../static/img/visual-marketing/kcli-pt.jpg'),
			ViewTitle: '한국고용노동교육원 청소년진로프로그램 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/kcli-pt.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 74,
			category: 'presentation',
			ptUrl: 'ku-ipp',
			thumbTitle: '건국대학교 <br>IPP형 일학습병행 공동훈련센터',
			thumbImg: require('../../static/img/visual-marketing/ku-ipp.jpg'),
			ViewTitle: '건국대학교 IPP형 일학습병행 공동훈련센터 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/ku-ipp.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 75,
			category: 'presentation',
			ptUrl: 'yongin-convergence',
			thumbTitle: '용인시 <br>융복합지원사업',
			thumbImg: require('../../static/img/visual-marketing/yongin-convergence.jpg'),
			ViewTitle: '용인시 융복합지원사업 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/yongin-convergence.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 76,
			category: 'proposal',
			ptUrl: 'kb-phone-insurance',
			thumbTitle: 'KB손해보험 휴대폰보험 <br>고객센터 운영업체 제안',
			thumbImg: require('../../static/img/visual-marketing/kb-phone-insurance.jpg'),
			ViewTitle: 'KB손해보험 휴대폰보험 고객센터 운영업체 위수탁계약 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/kb-phone-insurance.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 77,
			category: 'proposal',
			ptUrl: 'seohan-holdings',
			thumbTitle: '서한홀딩스 <br>회사소개서',
			thumbImg: require('../../static/img/visual-marketing/seohan-holdings.jpg'),
			ViewTitle: '서한홀딩스 회사소개서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/seohan-holdings.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 78,
			category: 'proposal',
			ptUrl: 'flying-doctors-korea',
			thumbTitle: 'Flying Doctors Korea <br>회사소개서',
			thumbImg: require('../../static/img/visual-marketing/flying-doctors-korea.jpg'),
			ViewTitle: 'Flying Doctors Korea 회사소개서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/flying-doctors-korea.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 79,
			category: 'presentation',
			ptUrl: 'jiat-special-vehicle',
			thumbTitle: '자동차융합기술원 <br>특장차 기반구축사업',
			thumbImg: require('../../static/img/visual-marketing/jiat-special-vehicle.jpg'),
			ViewTitle: '자동차융합기술원 특장차 안전·신뢰성 향상 및 기술융합 기반구축사업 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/jiat-special-vehicle.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 80,
			category: 'presentation',
			ptUrl: 'yongsan-development',
			thumbTitle: '서울시 용산국제업무지구 <br>개발구상 기자간담회',
			thumbImg: require('../../static/img/visual-marketing/yongsan-development.jpg'),
			ViewTitle: '서울시 용산국제업무지구 개발구상 기자간담회 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/yongsan-development.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 81,
			category: 'proposal',
			ptUrl: 'sky-networks-eco',
			thumbTitle: '스카이네트웍스 <br>친환경 자동차 특화 사업계획서',
			thumbImg: require('../../static/img/visual-marketing/sky-networks-eco.jpg'),
			ViewTitle: '스카이네트웍스 친환경 자동차 특화 사업계획서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/sky-networks-eco.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 82,
			category: 'presentation',
			ptUrl: 'humax-mobility',
			thumbTitle: '휴맥스모빌리티 <br>통합컨텍센터 구축 및 운영',
			thumbImg: require('../../static/img/visual-marketing/humax-mobility.jpg'),
			ViewTitle: '휴맥스모빌리티 통합컨텍센터 구축 및 운영 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/humax-mobility.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 83,
			category: 'proposal',
			ptUrl: 'mbk-pickup-delivery',
			thumbTitle: 'MBK <br>픽업&amp;딜리버리서비스 제안서',
			thumbImg: require('../../static/img/visual-marketing/mbk-pickup-delivery.jpg'),
			ViewTitle: 'MBK 픽업&amp;딜리버리서비스 제안서 디자인',
			ViewCategory: 'Proposal Design',
			ViewImg: require('../../static/img/visual-marketing-detail/mbk-pickup-delivery.jpg'),
			ViewImgAlt: '',
		},
		{
			index: 84,
			category: 'presentation',
			ptUrl: 'yongsan-development-future-city-seoul',
			thumbTitle: '서울시 <br>용산의 개발과 미래도시 서울',
			thumbImg: require('../../static/img/visual-marketing/yongsan-development-future-city-seoul.jpg'),
			ViewTitle: '서울시 용산의 개발과 미래도시 서울 PT 디자인',
			ViewCategory: 'Presentation Design',
			ViewImg: require('../../static/img/visual-marketing-detail/yongsan-development-future-city-seoul.jpg'),
			ViewImgAlt: '',
		},
	],
	bsdThumbs: [
		{
			title: '인천아시아경기대회조직위원회',
			desc: '인천아시아경기대회 홍보 PT 및 마케팅 컨설팅 외 다수',
		},
		{
			title: '인천아시아경기대회조직위원회',
			desc: '올림픽 총회, 파이널 보고, 분과위 보고 PT 컨설팅 외 다수',
		},
		{
			title: '인천장애인아시아경기대회조직위원회',
			desc: '2014인천장애인아시아경기대회 홍보 및 VIP PT 컨설팅 외 다수',
		},
		{
			title: '한국전력공사',
			desc: 'IR, 홍보, 경진대회 PT 디자인 및 컨설팅 외 다수',
		},
		{
			title: '한국남부발전',
			desc: 'Cyber Ware House Master Plan, 인사제도 혁신 PT 컨설팅 외 다수',
		},
		{
			title: '환경관리',
			desc: '공공하수처리시설 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '포스코건설',
			desc: '건설안전 우수사례 경진대회 PT 컨설팅 외 다수',
		},
		{
			title: '삼성엔지니어링',
			desc: '건설안전 우수사례 경진대회 PT 컨설팅',
		},
		{
			title: '국토교통부',
			desc: '국가 물류시설 선진화 홍보 PT 컨설팅 외 다수',
		},
		{
			title: '웅진씽크빅',
			desc: '웅진씽크빅 컴퓨터스쿨 경쟁입찰 표준제안 및 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: 'MANDO',
			desc: '해외 VIP 바이어 대상 홍보 PT 컨설팅 외 다수',
		},
		{
			title: '삼지전자',
			desc: '방송통신위원회 OIDD 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '메타넷 MCC',
			desc: '국민은행, BMW, 메트라이프, 한국전력, 유니세프 등 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: 'MPC',
			desc: '현대자동차, 국민건강보험, 국민연금 등 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '한국철도기술연구원',
			desc: '실시간 철도안전 통합제어시스템 개발 PT 컨설팅 외 다수',
		},
		{
			title: '한국가스공사',
			desc: '연료전시 홍보 PT 컨설팅 외 다수',
		},
		{
			title: '올레 KT',
			desc: '서울전략사업 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '인천시청',
			desc: '경제자유구역 투자유치 PT 컨설팅 외 다수',
		},
		{
			title: '선우정밀',
			desc: '지속가능경영보고 컨설팅, 안전보공공단 위험성평가 PT 컨설팅 외 다수',
		},
		{
			title: '공항시설관리',
			desc: '인천공항 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '장형기업',
			desc: '노사문화 우수기업, 지속경영가능보고서 컨설팅, 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '인프라개발',
			desc: '영남권국가물류터미널 PT 컨설팅 외 다수',
		},
		{
			title: '농촌진흥청',
			desc: '제2세대 바이오그린21 수주 PT 컨설팅 외 다수',
		},
		{
			title: '윌앤비전',
			desc: '아시아나항공, 한국전력, 하이마트, 중소기업유통센터 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '동부건설',
			desc: '인천 집단에너지시설 경쟁입찰 PT 컨설팅',
		},
		{
			title: '미시간랭귀지',
			desc: '삼성전자 외국어교육 경쟁입찰 컨설팅',
		},
		{
			title: 'IBS 인더스트리',
			desc: '서울파이낸스센터, 인천공항공사, 국민은행, 센터1경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '태가BM',
			desc: '신촌세브란스병원, 고대안암병원 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '건국대학교',
			desc: 'PRIME 사업 홍보 PT 컨설팅 외 다수',
		},
		{
			title: '부일정보링크',
			desc: '한국교직원공제회 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '토스',
			desc: 'KAKAO 뱅크 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '인천도시공사',
			desc: '상해 크루즈 홍보 PT 컨설팅 외 다수',
		},
		{
			title: 'LB휴넷',
			desc: 'AIA생명 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '대성글로벌네트웍',
			desc: '고용노동부, 국민건강보험 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: 'MMK',
			desc: '한국얀센, 중외제약, 동아제약 경쟁입찰 PT 컨설팅 및 디자인 외 다수',
		},
		{
			title: '서울시청',
			desc: '해외 관광 마케팅, 교통편의시스템 PT 컨설팅 외 다수',
		},
		{
			title: '자동차융합기술원',
			desc: '상용차산업 혁신성장 PT 컨설팅 외 다수',
		},
		{
			title: '한국현금결제',
			desc: 'B2B 현금결제시스템 “바로패스” 홍보 PT 컨설팅',
		},
		{
			title: '충청남도청',
			desc: '충청남도 신속집행 및 추경편성계획 PT 외 컨설팅 다수',
		},
		{
			title: '스카이네트웍스',
			desc: '벤츠 CS Clinic Report / 온사이트 보고서 컨설팅 외 다수',
		},
		{
			title: '전라북도청',
			desc: '전라북도 고용안정 선제대응 패키지 구축사업 PT 컨설팅',
		},
		{
			title: '신한신용정보',
			desc: '한국자산관리공사 경쟁입찰 컨설팅 외 다수',
		},
		{
			title: '거창',
			desc: '한국에너지관리공단 경쟁입찰 PT 컨설팅 외 다수',
		},
		{
			title: '군산자동차무역센터',
			desc: '군산시 새만금 자동차 수출복합센터 조성사업 경쟁입찰 컨설팅',
		},
	],
};



// WEBPACK FOOTER //
// ./src/data/store.js